export default __webpack_public_path__ + "static/media/english-to-greek-screenshot-04.05f11cf0.png";